export default class StoreAdjustmentDetail {
    _storeId;
    constructor({ storeId: _storeId, type: _type, amount: _amount, taxAmount: _taxAmount, totalAmount: _totalAmount, orderCount: _orderCount, }) {
        Object.assign(this, {
            _storeId,
            _type,
            _amount,
            _taxAmount,
            _totalAmount,
            _orderCount,
        });
    }
    get storeId() {
        return this._storeId;
    }
}
